var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Users/rory/Sites/deblois-electric/wp-content/themes/sage/node_modules/core-js/modules/_html.js
// module id = 72
// module chunks = 0